import evtForwarder from '../evtForwarder'

const createEvtForwarder = () => evtForwarder

export default createEvtForwarder
